// removed by extract-text-webpack-plugin
module.exports = {"Content":"Layout__Content__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/containers/Layout/Layout.scss
// module id = 112
// module chunks = 0